import React from 'react';
import PropTypes from 'prop-types';

// Renders an inline danger-styled alert
export default function InlineWarning({ id, className, dataTestId, children }) {
  return (
    <div
      className={className || undefined}
      id={id}
      data-test-id={dataTestId}
      role="alert">
      <small className="text-danger">{children}</small>
    </div>
  );
}

InlineWarning.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  children: PropTypes.node,
};

InlineWarning.defaultProps = {
  className: '',
};
